module.exports = __webpack_public_path__ + "static/media/11.83706a72.JPG";